import { defineMessages } from "react-intl";
const messages = defineMessages({
    addNewProspect: {
        id: "app.prospect.selector.addNewProspect.text",
        defaultMessage: "Create New Prospect",
    },
    prospectTrackingGuide: {
        id: "app.prospect.selector.prospect.trackingGuide.text",
        defaultMessage: "Tracked link data is reported in Prospect Intelligence. Prospects are identified by email address.",
    },
    searchLengthError: {
        id: "app.prospect.selector.prospect.searchErrorLength.text",
        defaultMessage: "Search should contain at least 3 characters.",
    },
});
export default messages;
